/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gashenyi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Nyacyina": ["Bwiyando", "Gashinge", "Kadehero", "Masoro", "Mukira", "Nyamure", "Rugarama", "Rugendabari", "Ruhore"],
  "Rukura": ["Gahihi", "Gikoro", "Kara", "Kirambo", "Murandi", "Nyamataha"],
  "Rutabo": ["Buhira", "Buturuba", "Gasanzwe", "Kabwika", "Kamurambo", "Kanwa", "Rubuga"],
  "Rutenderi": ["Gaseke", "Gatwa", "Gitaba", "Kabere", "Kabugomba", "Kibara", "Murambo"],
  "Taba": ["Busaro", "Bushita", "Gasharu", "Gihanga", "Kangomba", "Kanteko", "Murambi", "Mwisha", "Rutenderi"]
};